var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoandicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 50,
    viewBox: "0 0 246 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8009 15L39.2251 7.92523L39.1802 51.0967L51.8009 44V15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.043 0.5L0.307617 15V36.0053L36.4629 6.37009L26.043 0.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.307617 36.0053V44L26.043 58.5L35.1604 53.3527L25.7511 31.4494L0.307617 36.0053Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.338 55.6964H80.5006L76.8401 34.9977H76.2338V55.6964H68.4413V3.30363H81.1967C82.7687 3.30363 84.0937 3.8293 85.194 4.90257C86.2944 5.97583 86.8334 7.26813 86.8334 8.80136V29.5C86.8334 31.4275 86.0249 32.9388 84.4081 34.0121L88.2931 55.6964H88.338ZM79.0858 26.0393V12.3278C79.0858 11.364 78.6142 10.8822 77.671 10.8822H76.2563V27.3973H77.671C78.6142 27.3973 79.0858 26.9373 79.0858 26.0393Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.882 50.1986C114.882 51.7319 114.343 53.0242 113.242 54.0974C112.142 55.1707 110.817 55.6964 109.245 55.6964H102.194C100.622 55.6964 99.2744 55.1707 98.174 54.0974C97.0512 53.0242 96.4898 51.7319 96.4898 50.1986V8.80136C96.4898 7.26813 97.0512 5.97583 98.174 4.90257C99.2969 3.82931 100.644 3.30363 102.194 3.30363H109.245C110.817 3.30363 112.142 3.82931 113.242 4.90257C114.343 5.97583 114.882 7.26813 114.882 8.80136V50.1986ZM107.089 46.716V12.3278C107.089 11.364 106.618 10.8822 105.675 10.8822C104.731 10.8822 104.26 11.364 104.26 12.3278V46.716C104.26 47.6359 104.731 48.0959 105.675 48.0959C106.618 48.0959 107.089 47.6359 107.089 46.716Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.382 55.6964H130.175C128.603 55.6964 127.255 55.1707 126.155 54.0974C125.032 53.0242 124.471 51.7319 124.471 50.1986V8.80136C124.471 7.26813 125.032 5.97583 126.155 4.90257C127.278 3.82931 128.625 3.30363 130.175 3.30363H139.382V10.9041H133.678C132.735 10.9041 132.263 11.386 132.263 12.3497V46.7379C132.263 47.6579 132.735 48.1178 133.678 48.1178H139.382V55.7183V55.6964Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.609 3.30363L160.244 28.4267L169.586 55.6964H161.727L156.157 39.3127L155.281 41.6125V55.6964H147.489V3.30363H155.281V20.6511L161.794 3.30363H169.609Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.571 55.6964H193.66V3.30363H208.571V10.9041H201.452V24.0023H208.571L201.452 31.6027V48.1178H208.571V55.7183V55.6964Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245.692 55.6964H237.9V30.2885L232.196 55.6964H230.242L224.471 30.2885V55.6964H216.678V3.30363H223.774L231.23 33.9902L238.731 3.30363H245.692V55.6964Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.508 18.9864L187.372 3.52266L187.327 31.8875L180.837 16.7742L168.508 18.9864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoandicon);
export default __webpack_public_path__ + "static/media/logoandicon.5d5269c7fec59eb45a8d8ffb710ad921.svg";
export { ForwardRef as ReactComponent };